export function isMsgContainsIFrame(text) {
    const cleanedText = text?.replace(/```[\s\S]*?```/g, '');

    return /<iframe.*?\/?>[\s\S]*?<\/iframe>|<iframe.*?\/>/i.test(cleanedText);
}

export function isMsgContainsTable(msgText) {
    return msgText?.indexOf('<table') > -1;
}